import { render, staticRenderFns } from "./InventoryViewDetails.vue?vue&type=template&id=1f1411c6&"
import script from "./InventoryViewDetails.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports